<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="elevation-10">
          <v-card-actions>
            <v-row>
              <v-col
                cols="4"
              >
                <v-text-field
                  v-model="search"
                  placeholder="Key in announcement category name here"
                  append-icon="search"
                  label="Search Announcement Category"
                  hide-no-data
                  hide-selected
                  clearable 
                />
              </v-col>
              <v-col
                cols="4"
              >
                <v-select
                  v-model="statusFilter"
                  :items="items"
                  item-text="state"
                  item-value="value"
                  label="Category's Status"
                  placeholder="Active / Deleted"
                />
              </v-col>
              <v-col
                cols="2"
                offset-md="2"
              >
                <setup-announcement-category-dialog-create
                  @created="loadAnnouncementCategory"
                />
              </v-col>
            </v-row>
          </v-card-actions>
          <v-data-table
            :headers="headers"
            :items="filteredAnnouncementCategory"
            :loading="tableLoading"
            :search="search"
          >
            <template v-slot:item.name="{ item }">
              <div>
                <span>
                  {{ item.name }}
                </span>
              </div>
            </template>
            <template v-slot:item.action="{ item }">
              <span v-if="statusFilter">
                <setup-announcement-category-dialog-edit
                  :category="item"
                  @updated="refreshData"
                />
                <span class="mx-1" />
                <setup-announcement-category-dialog-delete
                  :category="item"
                  @deleted="refreshData"
                />
              </span>
              <span v-else>
                <setup-announcement-category-dialog-restore
                  :category="item"
                  @restored="refreshData"
                />
              </span>
            </template>
          </v-data-table>
        </v-card> 
      </v-col>
    </v-row>    
  </v-container>
</template>

<script>
  export default {
    components: {
      SetupAnnouncementCategoryDialogCreate: () => import('@/components/setup/newsletter/announcementCategory/DialogCreate'),
      SetupAnnouncementCategoryDialogDelete: () => import('@/components/setup/newsletter/announcementCategory/DialogDelete'),
      SetupAnnouncementCategoryDialogRestore: () => import('@/components/setup/newsletter/announcementCategory/DialogRestore'),
      SetupAnnouncementCategoryDialogEdit: () => import('@/components/setup/newsletter/announcementCategory/DialogEdit'),
    },
    metaInfo () {
      return {
        title: 'Announcement Category',
      }
    },
    data () {
      return {
        announcementCategories: [],
        trashedAnnouncementCategories: [],
        headers: [
          {
            text: 'Category',
            align: 'left',
            value: 'name',
          },
          {
            text: 'Actions',
            sortable: false,
            value: 'action',
          },
        ],

        search: '',
        statusFilter: { state: 'Active', value: true },
        items: [
          { state: 'Active', value: true },
          { state: 'Deleted', value: false },
        ],
        tableLoading: true,
      }
    },
    computed: {
      filteredAnnouncementCategory () {
        return this.statusFilter ? this.announcementCategories : this.trashedAnnouncementCategories
      },
    },
    created () {
      this.refreshData()
    },
    methods: {
      loadAnnouncementCategory () {
        this.$api.announcementCategories().list()
          .then(response => {
            this.announcementCategories = response.data
            this.tableLoading = false
          })
      },
      loadTrashedAnnouncementCategory () {
        this.$api.announcementCategories().listTrashed()
          .then(response => {
            this.trashedAnnouncementCategories = response.data
          })
      },
      refreshData () {
        this.loadAnnouncementCategory()
        this.loadTrashedAnnouncementCategory()
      },
    },
  }
</script>
